export default __webpack_public_path__ + "static/media/glassweb.687a7092.png";